export default {
  SITE_2: "/sitev2",
  STORE: "/store",
  MARKET_INFORMATION: "/market_information",
  PLANNING_MAP: "/planning/map",
  RESET_PASSWORD: "/reset_password",
};
